/* maxmax product labels logic start */

window.MaxmaxProductSticker = function(config) {
  var root = document.getElementById(config.rootId);
  if (!root) return;

  var labels = Array.prototype.slice.call(
    root.querySelectorAll('.nyx-media-wrapper > .custom-product-labels')
  );
  if (!labels.length) return;

  var gallery = document.getElementById(config.galleryId);
  if (!gallery) return;

  var dataEl = document.getElementById(config.dataId);
  if (!dataEl) return;

  var data;
  try {
    data = JSON.parse(dataEl.textContent || '{}');
  } catch (e) {
    return;
  }

  var variants = data.variants || [];
  var defaultVariantId = String(data.selected_variant_id || '');
  var defaultFeaturedMediaId = String(data.default_featured_media_id || '');

  function getCurrentVariantId() {
    var input =
      root.querySelector('form[action^="/cart/add"] input[name="id"]') ||
      root.querySelector('product-form input[name="id"]') ||
      root.querySelector('input[name="id"][data-selected-variant]');

    if (input && input.value) return String(input.value);
    return defaultVariantId;
  }

  function getCurrentVariant() {
    var id = getCurrentVariantId();

    return variants.find(function(v) {
      return String(v.id) === id;
    }) || null;
  }

  function getCurrentVariantFeaturedMediaId() {
    var v = getCurrentVariant();
    if (!v) return defaultFeaturedMediaId;

    return String(v.featured_media_id || defaultFeaturedMediaId || '');
  }

  function getActiveSlideMediaId() {
    var activeSlide = gallery.querySelector('.m-media-gallery__list .swiper-slide-active[data-media-id]');
    if (activeSlide) return String(activeSlide.getAttribute('data-media-id') || '');

    var currentSlide = gallery.querySelector('.m-media-gallery__list .swiper-slide[data-media-id]');
    if (currentSlide) return String(currentSlide.getAttribute('data-media-id') || '');

    return '';
  }

  function updateStickerVisibility() {
    var featuredMediaId = getCurrentVariantFeaturedMediaId();
    var activeMediaId = getActiveSlideMediaId();

    var shouldShow =
      featuredMediaId !== '' &&
      activeMediaId !== '' &&
      featuredMediaId === activeMediaId;

    labels.forEach(function(labelGroup) {
      labelGroup.style.display = shouldShow ? 'flex' : 'none';
    });
  }

  function delayedUpdate() {
    updateStickerVisibility();
    setTimeout(updateStickerVisibility, 80);
    setTimeout(updateStickerVisibility, 200);
    setTimeout(updateStickerVisibility, 400);
  }

  delayedUpdate();

  root.addEventListener('change', function(e) {
    if (e.target.matches('select[name^="options["], input[type="radio"], input[name="id"], select')) {
      delayedUpdate();
    }
  }, true);

  root.addEventListener('click', function() {
    setTimeout(updateStickerVisibility, 0);
    setTimeout(updateStickerVisibility, 120);
  }, true);

  var mediaList = gallery.querySelector('.m-media-gallery__list');

  if (mediaList) {
    new MutationObserver(function() {
      updateStickerVisibility();
    }).observe(mediaList, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  new MutationObserver(function() {
    delayedUpdate();
  }).observe(root, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['value']
  });

  window.addEventListener('load', delayedUpdate);
  window.addEventListener('resize', updateStickerVisibility);
};

/* maxmax product labels logic end */
